export default __webpack_public_path__ + "images/process_9.svg?4fa069b87eaa0d4b4b9a53cbb374554f";